import {
  Grid,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from '@usehatchapp/material';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

const SNIPPET_OPTIONS = ['[[Next Open Time]]'];

export const Response = ({
  checked,
  onChangeChecked,
  smsResponse,
  onChangeSmsResponse,
  editing,
}) => {
  const textFieldRef = useRef(null);
  const insertSnippetAtPosition = ({ target: { value } }) => {
    if (textFieldRef?.current) {
      const position = textFieldRef.current.selectionStart;
      const text = textFieldRef.current.value;
      const nextValue = `${text.slice(0, position)}${value}${text.slice(
        position,
      )}`;
      onChangeSmsResponse({ target: { value: nextValue } });
    }
  };
  return (
    <Grid container mt={2}>
      <Typography variant="overline">After Business Hours Response</Typography>
      <Grid mt={1} container flexWrap="nowrap" alignItems="center">
        <Switch
          data-test-id="11683188-5305-4141-ae08-fcc8e2d625f2"
          checked={checked}
          onChange={(e) => {
            return editing ? onChangeChecked(e) : null;
          }}
          disabled={!editing}
        />
        <Typography
          sx={{ color: !editing ? 'text.disabled' : 'inherit', ml: 1 }}
        >
          Send after business hours SMS response
        </Typography>
      </Grid>
      <TextField
        data-test-id="e9400604-b7b1-4de7-8d8f-cd1c29c3b819"
        fullWidth
        sx={{ mt: 1 }}
        multiline
        minRows="4"
        value={smsResponse}
        onChange={onChangeSmsResponse}
        inputProps={{ readOnly: !editing, ref: textFieldRef }}
        disabled={!editing}
      />
      <Select
        data-test-id="c7e88308-36b5-4509-96e3-569e1802cc5d"
        sx={{ minWidth: '200px', mt: 1 }}
        size="small"
        value="Snippets"
        onChange={insertSnippetAtPosition}
        disabled={!editing}
      >
        <MenuItem value="Snippets" disabled>
          Snippets
        </MenuItem>
        {SNIPPET_OPTIONS.map((option) => (
          <MenuItem value={option} key={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
};

Response.propTypes = {
  checked: PropTypes.bool.isRequired,
  editing: PropTypes.bool.isRequired,
  onChangeChecked: PropTypes.func.isRequired,
  onChangeSmsResponse: PropTypes.func.isRequired,
  smsResponse: PropTypes.string.isRequired,
};
